import { GET_REACTION_RE_ADMIN ,GET_REACTION_RE_EVOLVE,GET_ALL_PRODUCT_INFO,GET_ALL_EVENT_INFO } from '../../types'

const INITIAL_STATE = {
  allReactionReAdmin : [],
  allReactionReEvolve : [],
  allProductInfo:[],
  alleventInfo:[],
}

const prodeuctReactionReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_REACTION_RE_ADMIN:
      return {
        ...state,
        allReactionReAdmin: payload,
      }
      case GET_REACTION_RE_EVOLVE:
      return {
        ...state,
        allReactionReEvolve: payload,
      }
      case GET_ALL_PRODUCT_INFO:
        return {
          ...state,
          allProductInfo: payload,
        }
        case GET_ALL_EVENT_INFO:
          return {
            ...state,
            alleventInfo: payload,
          }
      
    default:
      return state
  }
}

export default prodeuctReactionReducer
